import {Button, Form, Input, Upload, Typography, Radio, Space} from "antd"
import {ArrowRight, Paperclip, File, Trash2} from "lucide-react"
import {images} from "../../../constants";
import {useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {YMaps, Map, FullscreenControl, SearchControl, Placemark} from "@pbe/react-yandex-maps";
import Localization from "../../../components/Localizations/Localization";
import {useTranslation} from "react-i18next";

const {Dragger} = Upload
const {Text} = Typography

const DeviceRegistrationFirstForm = ({handleClear, uploadProps}) => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [availabilityOption, setAvailabilityOption] = useState("business")
    const [coordinate, setCoordinate] = useState("");

    useEffect(() => {
        const savedData = localStorage.getItem("deviceRegistrationStep1");
        if (savedData) {
            form.setFieldsValue(JSON.parse(savedData));
        }
    }, [form]);

    const handleNext = async () => {
        try {
            await form.validateFields(); // Validate Step 1 fields
            if (coordinate === "") {
                alert(t("pages.devices.registrationForm.common.error.error2"));
                return;
            }
            const formData = form.getFieldsValue(); // Get form data

            console.log(formData);

            // Save Step 1 data to localStorage
            localStorage.setItem("deviceRegistrationStep1", JSON.stringify(formData));

            // Navigate to Step 2
            navigate("/device/registration/step/2");
        } catch (error) {
            console.error("Form validation error:", error);
        }
    };

    return (
        <div className="device-registration-container">
            <div className="banner">
                <div className="banner-logo">
                    <img src={images.deviceRegistrationBanner} alt="fiscalBOX"/>
                </div>
                <div className="banner-text">
                    <h1>{t("pages.devices.registrationForm.title")}</h1>
                    <p>{t("pages.devices.registrationForm.description")}</p>
                </div>
            </div>

            <div className="navigation-bar">
                <div>
                    <Localization/>
                </div>
                <div className="step-indicator">
                    <span className="step active">{t("pages.devices.registrationForm.steps.step1")}</span>
                    <span className="step-divider"></span>
                    <span className="step" onClick={handleNext}>{t("pages.devices.registrationForm.steps.step2")}</span>
                </div>
            </div>

            <div className="form-title">
                <h2>{t("pages.devices.registrationForm.form1.title")}</h2>
                <p>{t("pages.devices.registrationForm.form1.description")}</p>
            </div>

            <Form form={form} layout="vertical" className="registration-form">
                <Form.Item label={t("pages.devices.registrationForm.form1.field1.label")} name="email"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <Input placeholder={t("pages.devices.registrationForm.form1.field1.placeholder")}/>
                </Form.Item>

                <Form.Item label={t("pages.devices.registrationForm.form1.field2.label")} name="companyName"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <Input placeholder={t("pages.devices.registrationForm.form1.field2.placeholder")}/>
                </Form.Item>

                <Form.Item label={t("pages.devices.registrationForm.form1.field3.label")} name="managerName"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <Input placeholder={t("pages.devices.registrationForm.form1.field3.placeholder")}/>
                </Form.Item>

                <Form.Item label={t("pages.devices.registrationForm.form1.field4.label")} name="inn"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <Input placeholder={t("pages.devices.registrationForm.form1.field4.placeholder")}/>
                </Form.Item>

                <Form.Item label={t("pages.devices.registrationForm.form1.field5.label")} name="quantityDevice"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <Input placeholder={t("pages.devices.registrationForm.form1.field5.placeholder")}/>
                </Form.Item>

                <Form.Item label={t("pages.devices.registrationForm.form1.field6.label")} name="marketName"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <Input placeholder={t("pages.devices.registrationForm.form1.field6.placeholder")}/>
                </Form.Item>

                <Form.Item label={t("pages.devices.registrationForm.form1.field7.label")} name="nameDevices"
                           rules={[{
                               required: false,
                               message: t("pages.devices.registrationForm.common.error.error1")
                           }]}>
                    <Input placeholder={t("pages.devices.registrationForm.form1.field7.placeholder")}/>
                </Form.Item>

                <Form.Item label={t("pages.devices.registrationForm.form1.field8.label")} name="marketType"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <Input placeholder={t("pages.devices.registrationForm.form1.field8.placeholder")}/>
                </Form.Item>

                <Form.Item label={t("pages.devices.registrationForm.form1.field9.label")} name="marketCity"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <Input placeholder={t("pages.devices.registrationForm.form1.field9.placeholder")}/>
                </Form.Item>

                <Form.Item label={t("pages.devices.registrationForm.form1.field10.label")} name="marketDistrict"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <Input placeholder={t("pages.devices.registrationForm.form1.field10.placeholder")}/>
                </Form.Item>

                <Form.Item label={t("pages.devices.registrationForm.form1.field11.label")} name="marketStreet"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <Input placeholder={t("pages.devices.registrationForm.form1.field11.placeholder")}/>
                </Form.Item>

                <Form.Item label={t("pages.devices.registrationForm.form1.field12.label")} name="marketMahalla"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <Input placeholder={t("pages.devices.registrationForm.form1.field12.placeholder")}/>
                </Form.Item>

                <Form.Item label={t("pages.devices.registrationForm.form1.field13.label")} name="marketLocation"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <YMaps>
                        <div style={{width: '100%', height: '500px'}}>
                            <Map
                                defaultState={{center: [41.2988036, 69.2721706], zoom: 10}}
                                onClick={(e) => {
                                    const coords = e.get("coords");
                                    setCoordinate(coords);
                                    form.setFieldsValue({marketLocation: coords});
                                }}
                                style={{width: '100%', height: '100%'}}
                            >
                                <FullscreenControl/>
                                <SearchControl options={{
                                    float: 'right'
                                }}/>
                                <Placemark geometry={[coordinate[0], coordinate[1]]}/>
                            </Map>
                        </div>
                    </YMaps>
                </Form.Item>

                <Form.Item label={t("pages.devices.registrationForm.form1.field14.label")} name="phoneNumber"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <Input placeholder={t("pages.devices.registrationForm.form1.field14.placeholder")}/>
                </Form.Item>

                <Form.Item label={t("pages.devices.registrationForm.form1.field15.label")} name="certificateFile"
                           className="upload-form-item"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <div className="upload-section">
                        <Dragger {...uploadProps}>
                            <p className="ant-upload-drag-icon">
                                <Paperclip size={28}/>
                            </p>
                            <p className="ant-upload-text">{t("pages.devices.registrationForm.common.upload.label")}</p>
                            <p className="ant-upload-hint">
                                {t("pages.devices.registrationForm.form1.field15.upload.description")}
                            </p>
                        </Dragger>
                        <div className="upload-info">
                            <Text type="secondary">
                                <File size={14} style={{marginRight: "5px", verticalAlign: "middle"}}/>
                                {t("pages.devices.registrationForm.common.upload.secondary")}
                            </Text>
                        </div>
                    </div>
                </Form.Item>

                <Form.Item label={t("pages.devices.registrationForm.form1.field16.label")} name="contractFile"
                           className="upload-form-item"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <div className="upload-section">
                        <Dragger {...uploadProps}>
                            <p className="ant-upload-drag-icon">
                                <Paperclip size={28}/>
                            </p>
                            <p className="ant-upload-text">{t("pages.devices.registrationForm.common.upload.label")}</p>
                            <p className="ant-upload-hint">
                                {t("pages.devices.registrationForm.form1.field16.upload.description")}
                            </p>
                        </Dragger>
                        <div className="upload-info">
                            <Text type="secondary">
                                <File size={14} style={{marginRight: "5px", verticalAlign: "middle"}}/>
                                {t("pages.devices.registrationForm.common.upload.secondary")}
                            </Text>
                        </div>
                    </div>
                </Form.Item>

                <Form.Item label={t("pages.devices.registrationForm.form1.field17.label")} name="logoFile"
                           className="upload-form-item">
                    <div className="upload-section">
                        <Dragger {...uploadProps}>
                            <p className="ant-upload-drag-icon">
                                <Paperclip size={28}/>
                            </p>
                            <p className="ant-upload-text">{t("pages.devices.registrationForm.common.upload.label")}</p>
                            <p className="ant-upload-hint">
                                {t("pages.devices.registrationForm.form1.field17.upload.description")}
                            </p>
                        </Dragger>
                        <div className="upload-info">
                            <Text type="secondary">
                                <File size={14} style={{marginRight: "5px", verticalAlign: "middle"}}/>
                                {t("pages.devices.registrationForm.common.upload.secondary")}
                            </Text>
                        </div>
                    </div>
                </Form.Item>

                <Form.Item label={t("pages.devices.registrationForm.form1.field18.label")}
                           name="programName"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <Input placeholder={t("pages.devices.registrationForm.form1.field18.placeholder")}/>
                </Form.Item>

                <Form.Item label={t("pages.devices.registrationForm.form1.field19.label")}
                           name="workPeriod"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <Radio.Group
                        value={availabilityOption}
                        onChange={(e) => setAvailabilityOption(e.target.value)}
                        className="availability-radio-group"
                    >
                        <Space direction="vertical">
                            <Radio value="9:00-18:00" className="radio-option">
                                {t("pages.devices.registrationForm.form1.field19.option1.label")}
                            </Radio>
                            <Radio value="24/7" className="radio-option">
                                {t("pages.devices.registrationForm.form1.field19.option2.label")}
                            </Radio>
                            <Radio value="other" className="radio-option">
                                {t("pages.devices.registrationForm.form1.field19.option3.label")}
                                {availabilityOption === "other" ? (
                                    <Input
                                        className="other-input"
                                        placeholder={t("pages.devices.registrationForm.form1.field19.otherField.placeholder")}
                                        style={{width: "100%", marginLeft: 10, maxWidth: 400}}
                                    />
                                ) : null}
                            </Radio>
                        </Space>
                    </Radio.Group>
                </Form.Item>

                <div className="button-container">
                    <Button icon={<ArrowRight size={16}/>} type="primary" onClick={() => handleNext(form)}
                            className="next-button">
                        {t("pages.devices.registrationForm.buttons.button3")}
                    </Button>
                    <Button icon={<Trash2 size={16}/>} type="dashed" danger onClick={() => handleClear(form)}
                            className="clear-button">
                        {t("pages.devices.registrationForm.buttons.button4")}
                    </Button>
                </div>
            </Form>
        </div>
    );
};

export default DeviceRegistrationFirstForm;
